import React, { useState } from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { FiDownload, FiSearch } from "react-icons/fi";
import { FaRegThumbsUp, FaRegThumbsDown } from "react-icons/fa";
import { GoAlert } from "react-icons/go";
import { IoDocumentTextOutline } from "react-icons/io5";
import { LiaInfoCircleSolid } from "react-icons/lia";
import { FaArrowRightLong } from "react-icons/fa6";
import styles from "./PaperInsights.module.css";
import CustomButton from "./CustomButton";
import DropdownInput from "./Inputs/DropdownInput";
import ShortTextInput from "./Inputs/ShortTextInput";
import { submitFeedback } from "../api/Api";
import { showToast } from "../utils/toastUtils";
import SubmitFeedbackModal from "./modals/SubmitFeedbackModal";
import { FaThumbsUp, FaThumbsDown } from "react-icons/fa";
import VoteBox from "./ui/vote/VoteBox";

export const StatCard = ({ icon, count, label, iconBg, iconColor }) => (
  <Col md={4}>
    <div
      className="bg-white border p-3 d-flex align-items-center"
      style={{ borderRadius: "12px" }}
    >
      <div
        className={`rounded-circle ${iconBg} ${iconColor} p-2 me-3 d-flex align-items-center justify-content-center`}
      >
        {icon}
      </div>
      <div className="d-flex flex-column">
        <span className="fw-bold fs-5">{count}</span>
        <span className="text-secondary fw-medium">{label}</span>
      </div>
    </div>
  </Col>
);

export const SearchAndFilter = ({ filter, setFilter }) => (
  <Row className="mb-4 justify-content-between align-items-center">
    {/* Search */}
    <Col md={5}>
      <div className="position-relative">
        <ShortTextInput
          name="search"
          value={filter.Search}
          onChange={(e) => setFilter({ ...filter, Search: e.target.value })}
          placeholder="Search"
          className="bg-white"
          containerClassName="mb-0"
          fullWidth
          maxWidth="100%"
          id="searchInput"
        />
        <div
          className="position-absolute"
          style={{ right: "15px", top: "8px" }}
        >
          <FiSearch className="text-secondary" />
        </div>
      </div>
    </Col>

    {/* Filters */}
    <Col md="auto" className="d-flex align-items-center pb-3">
      <span className="text-secondary me-2 text-nowrap">Filter By</span>
      <div>
        <DropdownInput
          name="filterBy"
          options={[
            { id: "critical", name: "Critical Issues" },
            { id: "warning", name: "Warnings" },
            { id: "fixed", name: "Fixed Items" },
            { id: "todo", name: "To Do" },
          ]}
          value={filter.FilterBy}
          onChange={(e) => setFilter({ ...filter, FilterBy: e.target.value })}
          placeholder="Select here"
          className="bg-white"
          fullWidth
          maxWidth="200px"
          noOptionsText="No options available"
          id="filterByDropdown"
        />
      </div>
      {/*<DropdownInput
      <span className="text-secondary me-2 text-nowrap">Sort By</span>
     
        name="sortBy"
        options={[
          { id: "newest", name: "Newest First" },
          { id: "oldest", name: "Oldest First" },
          { id: "priority", name: "Priority" },
        ]}
        value={filter.SortBy}
        onChange={(e) => setFilter({ ...filter, SortBy: e.target.value })}
        placeholder="Select here"
        className="bg-white"
        maxWidth="200px"
        noOptionsText="No options available"
        id="sortByDropdown"
      />*/}
    </Col>
  </Row>
);

// this card is used to show the validation insights of the paper
export const ValidationCard = ({
  item,
  onRate,
  onMarkFixed,
  search,
  highlightText,
  isRatedLocally,
  paperId,
  ratedItems,
  feedbackType,
}) => {
  const pass = item?.isPassed === true; // this is for pass insights determined by the AI Agent
  const fail = item?.isPassed === "fail"; // this is for AI Agent failures

  return (
    <Card
      className={`mb-3 p-2 mx-2 ${styles.cardBase} ${
        item.is_marked_as_fixed || pass
          ? styles.cardFixed
          : fail
          ? styles.cardFail
          : ""
      }`}
    >
      <Card.Body className="p-3">
        <div className="d-flex">
          {/* Left Icon */}
          <div>
            <div
              className="me-3 p-2 d-flex align-items-center justify-content-center rounded-circle"
              style={{
                backgroundColor: "#f7f7f7",
              }}
            >
              <IoDocumentTextOutline
                className="p4 text-warning"
                style={{ width: "auto" }}
              />
            </div>
          </div>

          {/* Main Content */}
          <div className="flex-grow-1">
            <h6
              className={`mb-1 fw-medium ${
                item.is_marked_as_fixed ? "text-decoration-line-through" : ""
              }`}
            >
              {highlightText(item.title, search)}
            </h6>
            <p className="mb-1 fw-bold text-secondary">{item.context}</p>
            {/* <p className="mb-1 text-danger fw-medium">
              Section -{" "}
              <span
                className={
                  item.is_marked_as_fixed? "text-decoration-line-through text-muted": "text-muted"
                }
              >
                {item.section}
              </span>
            </p> */}
            <p
              className={`mb-2 ${
                item.is_marked_as_fixed
                  ? "text-decoration-line-through text-muted"
                  : ""
              }`}
            >
              {highlightText(item.description, search)}
            </p>

            {/* Tags */}
            <div className="mb-2">
              <span className="badge p5 d-inline-flex align-items-center fw-medium bg-danger bg-opacity-10 text-danger rounded-pill p-2 me-2 text-capitalize">
                <LiaInfoCircleSolid className="me-1" /> {item.severity}
              </span>
              <span className="badge p5 fw-medium bg-primary bg-opacity-10 text-primary rounded-pill p-2 me-2">
                {item.warningSection}
              </span>
            </div>
          </div>

          {/* Right Action button*/}
          <div className="d-flex flex-column justify-content-between align-items-end ms-3 text-end">
            {pass ? (
              <Button className="btn-small mb-3 py-1 fw-medium text-nowrap rounded-3 px-2 bg-success text-white">
                Pass
              </Button>
            ) : (
              <Button
                variant={
                  item.is_marked_as_fixed
                    ? "outline-success"
                    : "outline-secondary"
                }
                className={`btn-small mb-3 py-1 fw-medium text-nowrap rounded-3 px-2 ${
                  pass ? "bg-success text-white" : ""
                }`}
                onClick={() => onMarkFixed(item.id, !item.is_marked_as_fixed)}
              >
                {pass
                  ? "Pass"
                  : item.is_marked_as_fixed
                  ? "Fixed"
                  : "Mark As Fixed"}
              </Button>
            )}
          </div>
        </div>

        {/* Aligned HR and Suggestion + Rating */}
        <div style={{ marginLeft: "56px", marginRight: "10px" }}>
          <hr className="my-3" style={{ borderColor: "#cac4c4" }} />

          <div className="d-flex flex-wrap justify-content-end">
            {/* Suggestion Block */}
            {
              <div className="d-flex align-items-center flex-wrap flex-grow-1">
                <span
                  className={`${fail ? "text-danger" : "text-success"} me-2`}
                >
                  <FaArrowRightLong />
                </span>
                <span className={`${fail?"text-danger":"text-success"} fw-medium me-2`}>{fail?"Unable to validate": "Reasoning"}:</span>
                <span
                  className={`${
                    item.is_marked_as_fixed
                      ? "text-decoration-line-through text-muted fw-medium"
                      : "text-muted fw-medium"
                  }`}
                >
                  {highlightText(item.suggestion, search)}
                </span>
              </div>
            }

            {/* Rating Block */}
            <VoteBox
              itemId={item.id}
              feedbackType={feedbackType}
              onRate={onRate}
              additionalData={[paperId]}
            />
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export const PaperInsights = ({
  insights,
  setActiveStep, // used for navigation to the next step when comes through manuscript validator page
  handleCheckChange,
  hideNextButton,
  hideExportButton,
}) => {
  const [ratedItems, setRatedItems] = useState({}); // this is used to store the rated items locally
  const [feedbackTypes, setFeedbackTypes] = useState({}); // this is used to store the feedback types locally
  const [showFeedbackModal, setShowFeedbackModal] = useState(false); // this is used to show the feedback modal
  const [currentInsight, setCurrentInsight] = useState(null); // this is used to store the current insight for which feedback modal is opened

  const [filter, setFilter] = useState({
    Search: null,
    FilterBy: null,
    SortBy: null,
  });
  // filter insights based on search and filter criteria and sort them by the selected criteria modify insights
  const filteredInsights = insights
    ?.filter((item) => {
      // Search filter
      const searchMatch = filter.Search
        ? item.title.toLowerCase().includes(filter.Search.toLowerCase()) ||
          item.description
            .toLowerCase()
            .includes(filter.Search.toLowerCase()) ||
          item.section.toLowerCase().includes(filter.Search.toLowerCase())
        : true;

      // Type filter (e.g., 'critical', 'warning', 'fixed')
      let typeMatch = true;

      if (filter.FilterBy) {
        switch (filter.FilterBy) {
          case "fixed":
            typeMatch = item.is_marked_as_fixed || item.isPassed === true;
            break;
          case "todo":
            typeMatch =
              !item.is_marked_as_fixed &&
              (item.isPassed === false || item.isPassed === "fail");
            break;
          default:
            typeMatch = item.severity === filter.FilterBy;
        }
      }

      return searchMatch && typeMatch;
    })
    .sort((a, b) => {
      if (filter.SortBy === "newest") {
        return new Date(b.created_at) - new Date(a.created_at); // newest first
      } else if (filter.SortBy === "oldest") {
        return new Date(a.created_at) - new Date(b.created_at); // oldest first
      } else if (filter.SortBy === "priority") {
        const priority = { critical: 1, warning: 2, suggestion: 3 };
        return priority[a.type] - priority[b.type];
      }
      return 0;
    });

  // highlight the search text in the title and description of the validation card
  const highlightText = (text, search) => {
    if (!search) return text;

    const regex = new RegExp(`(${search})`, "gi");
    const parts = text.split(regex);
    return parts.map((part, i) =>
      regex.test(part) ? <mark key={i}>{part}</mark> : part
    );
  };

  const handleRateSuggestion = async (
    feedbackType,
    insightId,
    feedbackMessage,
    paperId
  ) => {
    // for debugging
    // console.log("feedbackType", feedbackType);
    // console.log("insightId", insightId);
    // console.log("paperId", paperId);
    // console.log("feedbackMessage", feedbackMessage);

    const response = await submitFeedback(paperId, insightId, {
      feedback_type: feedbackType,
      feedback: feedbackMessage,
    });
    if (response?.status === 200) {
      if (!!feedbackType) showToast("Thanks for your feedback!", "success");
      setRatedItems((prev) => ({ ...prev, [insightId]: true }));
      setFeedbackTypes((prev) => ({ ...prev, [insightId]: feedbackType }));
    } else {
      setFeedbackTypes((prev) => ({ ...prev, [insightId]: null }));
      showToast("Failed to submit feedback", "error");
    }
  };

  return (
    <Container className="p-3 ">
      <Row className="mb-4">
        <Col className="mx-2">
          <h4 className="fw-bold mb-0 ">Manuscript Validations</h4>
          <p className="text-secondary mb-0 ">
            Identify and fix issues in your research paper
          </p>
        </Col>
        {/* <Col xs="auto">
        {!hideExportButton && 
        <Button
            variant="primary"
            className="rounded d-flex align-items-center "
            style={{ backgroundColor: "#0ea5e9", borderColor: "#0ea5e9" }}
          >
            <FiDownload className="me-2" /> Export Validation Report
          </Button>
          }
        </Col> */}
      </Row>

      {/* Stats Cards */}
      <Row className="mb-4">
        <StatCard
          icon={<LiaInfoCircleSolid size={32} />}
          count={
            insights?.filter((item) => item?.severity === "critical")?.length
          }
          label="Critical Issues"
          iconBg="bg-danger bg-opacity-10"
          iconColor="text-danger"
        />
        <StatCard
          icon={<GoAlert size={30} />}
          count={
            insights?.filter((item) => item?.severity === "warning")?.length
          }
          label="Warnings"
          iconBg="bg-warning bg-opacity-10"
          iconColor="text-warning"
        />
        <StatCard
          icon={<LiaInfoCircleSolid size={32} color=" #236ABC" />}
          count={
            insights?.filter((item) => item?.severity === "suggestion")?.length
          }
          label="Suggestions"
          iconBg="bg-info bg-opacity-10"
          iconColor=""
        />
      </Row>

      {/* Search and Filter */}
      <SearchAndFilter filter={filter} setFilter={setFilter} />

      {/* Validation Cards */}
      <div className="mb-4">
        {filteredInsights?.length === 0 && (
          <div className="text-center p-4 p4">No matching insights found</div>
        )}

        {filteredInsights?.map((item) => (
          <ValidationCard
            key={item.id}
            item={item}
            onRate={handleRateSuggestion}
            onMarkFixed={handleCheckChange}
            search={filter.Search}
            highlightText={highlightText}
            paperId={item.paper_id}
            isRatedLocally={ratedItems[item.id] === true} // check if the item is rated locally
            feedbackType={feedbackTypes[item.id] || item.feedback_type} // get the feedback type
          />
        ))}

        {/* <SubmitFeedbackModal
          show={showFeedbackModal}
          handleClose={() => setShowFeedbackModal(false)}
          paperId={currentInsight?.paperId}
          insightId={currentInsight?.insightId}
          onSuccess={() =>
            setRatedItems((prev) => ({
              ...prev,
              [currentInsight?.insightId]: true,
            }))
          }
        /> */}
      </div>

      {/* Next Button */}
      {hideNextButton ? null : (
        <div className="d-flex justify-content-center mb-3">
          <CustomButton
            style={{ backgroundColor: "#0ea5e9", borderColor: "#0ea5e9" }}
            onClick={() => setActiveStep(1)}
          >
            <span className="fw-medium">&gt;&gt; Next: Post Checks</span>
          </CustomButton>
        </div>
      )}
    </Container>
  );
};

export default PaperInsights;
